module.exports = __webpack_public_path__ + "static/media/cy-wx-qrcode.0ef52865.png";